import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { of, Subject } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { NotificationType } from '../../models/notification-type';
import { NotificationService } from '../../services/notification/notification.service';
import { ResendAccessCodeService } from './resend-access-code.service';

@Component({
    selector: 'upsc-resend-access-code',
    templateUrl: './resend-access-code.component.html',
    styleUrls: ['./resend-access-code.component.scss', '../ship-details-actions/ship-details-action-icon.component.scss'],
    standalone: true,
    providers: [ResendAccessCodeService, NotificationService],
    imports: [
        CommonModule,
        NgOptimizedImage,
        TranslateModule,
        MatProgressSpinnerModule,
    ],
})
export class ResendAccessCodeComponent implements OnDestroy {
    @Input() public shipmentId: string;

    @HostBinding('class') public hostClass = 'resend-access-code';

    public isInProgress = false;
    private ngDestroyed$ = new Subject<void>();

    public constructor(private readonly resendAccessCodeService: ResendAccessCodeService,
                       private readonly notificationService: NotificationService,
    ) {}

    public ngOnDestroy(): void {
        this.ngDestroyed$.next();
        this.ngDestroyed$.complete();
    }

    public resendAccessPointCode(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.isInProgress = true;
        this.resendAccessCodeService.resendAccessPointCode(this.shipmentId)
            .pipe(
                takeUntil(this.ngDestroyed$),
                catchError((err) => {
                    this.notificationService.notify(
                        'There was an error while resending access code. Please try again later.',
                        'Error while resending access code',
                        NotificationType.ERROR,
                    );

                    console.error(err);
                    return of(false);
                }),
                finalize(() => {
                    this.isInProgress = false;
                }),
            )
            .subscribe(
                (result) => {
                    if (!result) { return; }

                    this.notificationService.notify(
                        'The Access Code has been sent to the recipient\'s email address.',
                        'Access Code Sent Successfully',
                        NotificationType.SUCCESS,
                    );
                },
            );
    }
}
